"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Location() {
  const reduceMotion = useReducedMotion();
  const facts = [{
    label: "Service",
    value: "Mobile Detailing"
  }, {
    label: "Coverage",
    value: "Miami & Surrounds"
  }, {
    label: "Location",
    value: "Home or Office"
  }, {
    label: "Booking",
    value: "WhatsApp Priority"
  }];
  const contourPattern = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='600' height='600' viewBox='0 0 600 600'><g fill='none' stroke='%23f5ecd6' stroke-width='0.6' opacity='0.5'><path d='M-50 120 Q150 80 300 130 T650 110'/><path d='M-50 180 Q180 140 320 190 T650 170'/><path d='M-50 240 Q160 200 300 250 T650 230'/><path d='M-50 300 Q200 260 340 310 T650 290'/><path d='M-50 360 Q170 320 310 370 T650 350'/><path d='M-50 420 Q190 380 330 430 T650 410'/><path d='M-50 480 Q160 440 300 490 T650 470'/><path d='M-50 540 Q180 500 320 550 T650 530'/></g></svg>`)}`;
  const initialHidden = reduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 24
  };
  const visible = {
    opacity: 1,
    y: 0
  };
  return;
}